export default [
  {
    type: 'subtitle',
    content: 'المقدمة',
  },
  {
    type: 'text',
    content: 'شكرًا لاختيارك الاشتراك في تمارا سمارت!',
  },
  {
    type: 'text',
    content:
      'قبل قراءة الشروط والأحكام الخاصة بتمارا سمارت (المشار إليها فيما يلي باسم "الشروط والأحكام الخاصة بتمارا سمارت")، يرجى التأكد من أنك قرأت بعناية الشروط والأحكام الخاصة بالعميل، لأنها تشكل جزءًا من اتفاقيتك مع تمارا ويجب قراءتهما معًا.',
  },
  {
    type: 'text',
    content:
      'من خلال الاشتراك، فإنك تقر وتوافق على الشروط والأحكام الخاصة بتمارا سمارت.',
  },
  {
    type: 'text',
    content:
      'تحتفظ تمارا بالحق − وفقًا لتقديرها الخاص والمطلق من وقت لآخر ولأي سبب − في تعديل الميزات والمحتوى الموضح في البند (2) أدناه، وتعديل أسعار الفواتير بموجب البند (3) أدناه، وتعديل الشروط والأحكام الخاصة بتمارا سمارت. وسنقدم لك إشعارًا بهذه التعديلات قبل ثلاثين (30) يومًا على الأقل، ما لم تسمح الأنظمة المعمول بها بخلاف ذلك أو تتطلبه. إن استمرارك في استخدام ودفع اشتراكك بعد إبلاغك بهذه التعديلات يشكل إقرارًا منك بأنك قرأت هذه التعديلات وفهمتها وقبلتها. وإذا كنت تريد إلغاء اشتراكك نتيجة لهذه التعديلات، فيرجى اتباع الخطوات الواردة في البند (4) أدناه.',
  },
  {
    type: 'text',
    content:
      'وُضعت هذه الشروط والأحكام الخاصة بتمارا سمارت في ثلاثة أقسام (لتسهيل التنقل بينهم بقدر الإمكان):',
  },
  {
    type: 'text',
    content:
      '<span class="text-decoration-underline">القسم الأول</span> (كيفية التواصل) – يوضح هذا القسم كيفية التواصل معنا.',
  },
  {
    type: 'text',
    content:
      '<span class="text-decoration-underline">القسم الثاني</span> (اشتراكك) – يوضح هذا القسم جميع المعلومات التي تحتاج إلى معرفتها فيما يتعلق باشتراكك وكيفية عمله.',
  },
  {
    type: 'text',
    content:
      '<span class="text-decoration-underline">القسم الثالث</span> (التعريفات) – يتضمن هذا شرحًا لما تعنيه المصطلحات الواردة والمستخدمة في هذه الشروط والأحكام الخاصة بتمارا سمارت.',
  },
  {
    type: 'subtitle',
    content: 'القسم الاول',
  },
  {
    type: 'text',
    content: '<strong>كيفية التواصل</strong>',
  },
  {
    type: 'text',
    content:
      'ذا كنت ترغب في التواصل معنا بخصوص اشتراكك، فيرجى الاستعانة <a href="https://support.tamara.co/hc/en-us#customers">بمركز مساعدة العملاء</a>',
  },
  {
    type: 'text',
    content:
      'إذا كان لديك حساب في تمارا معنا، فلا تنس التحقق من رسائل البريد الإلكتروني أو الرسائل المرسلة إليك عبر حساب تمارا الخاص بك، حيث إن هذه هي الطريقة المعتادة التي سنتواصل بها معك بخصوص الاشتراك الخاص بك.',
  },
  {
    type: 'subtitle',
    content: 'القسم الثاني',
  },
  {
    type: 'text',
    content: '<strong>الاشتراك الخاص بك</strong>',
  },
  {
    type: 'text',
    content: '<strong>1. طلب الاشتراك الخاص بك</strong>',
  },
  {
    type: 'text',
    content:
      '<strong>1.1.</strong> بموجب موافقة تمارا وامتثالك للشروط والأحكام الخاصة بتمارا سمارت، يمكنك الوصول إلى تمارا سمارت واستخدامها على أساس الاشتراك بالقدر والمدة المنصوص عليها في نموذج الطلب.',
  },
  {
    type: 'text',
    content:
      '<strong>1.2.</strong> يمكنك شراء الاشتراك مباشرة عبر تطبيق الجوال أو منصة التاجر.',
  },
  {
    type: 'text',
    content: '<strong>1.3.</strong> لن يُسمح لك بشراء الاشتراك إلا في حالة:',
  },
  {
    type: 'text',
    content: '<strong>1.3.1.</strong> كان عمرك يزيد عن 18 عامًا.',
  },
  {
    type: 'text',
    content:
      '<strong>1.3.2.</strong> أنك أحد مستخدمي خدمات تمارا ولديك حساب تمارا نشط.',
  },
  {
    type: 'text',
    content:
      '<strong>1.3.3.</strong> إن حساب تمارا الخاص بك في وضع جيد، وليس لديك أي دفعات مستحقة أو معلقة في حالة التخلف عن السداد.',
  },
  {
    type: 'text',
    content:
      '<strong>1.4.</strong> تشكل عملية شراء الاشتراك عرضًا لنا لشراء الاشتراك. سيكون قبولنا لهذا العرض عندما نرسل إليك رسالة تأكيد بالبريد الإلكتروني لقبول الاشتراك الخاص بك. إذا لم نتمكن من قبول طلبك، فسنبلغك بذلك عبر البريد الإلكتروني ولن نفرض عليك رسومًا مقابل الاشتراك.',
  },
  {
    type: 'text',
    content: '<strong>2. الاشتراك الخاص بك</strong>',
  },
  {
    type: 'text',
    content:
      '<strong>2.1.</strong> من خلال شراء الاشتراك ودفع أي رسوم اشتراك شهرية متكررة للحفاظ على الاشتراك الخاص بك نشطًا، سيكون لديك حق الوصول إلى ما يلي:',
  },
  {
    type: 'text',
    content:
      '<strong>2.1.1. الاسترداد النقدي:</strong>  استرداد نقدي قدره% 1 على استخدامك لخدمات تمارا حتى حد شهري معين تحدده تمارا ويتم إخطارك به من وقت لآخر. تحتفظ تمارا بالحق في استعادة المبالغ النقدية المستردة في حالة استرداد الأموال.',
  },
  {
    type: 'text',
    content:
      '<strong>2.1.2. تجربة كشف الحساب:</strong> خيار تجميع جميع الأقساط المستحقة لـتمارا في شهر معين من استخدامك لخدمات تمارا في دفعة شهرية واحدة. سيكون كشف الحساب متاحًا لك في اليوم الخامس والعشرين من كل شهر، وبعد ذلك سيكون لديك مهلة حتى اليوم الأول من الشهر التالي لتسديد الدفعة الشهرية الواحدة. سيتم إضافة أي استخدام لخدمات تمارا بين اليوم الخامس والعشرين من الشهر واليوم الأول من الشهر التالي إلى كشف حساب الشهر التالي.',
  },
  {
    type: 'text',
    content:
      '<strong>2.1.3. برنامج تمارا لحماية المشتري:</strong> تفاصيل البرنامج والشروط والأحكام متاحة على الموقع الإلكتروني.',
  },
  {
    type: 'text',
    content:
      '<strong>2.1.4. العروض والخصومات الحصرية:</strong> العديد من العروض والخصومات الحصرية.',
  },
  {
    type: 'text',
    content:
      '<strong>2.2.</strong> تنطبق تمارا سمارت فقط على خدمات تمارا المستخدمة بعد تاريخ الاشتراك الخاص بك. أي استخدام لخدمات تمارا يحدث قبل تاريخ الاشتراك الخاص بك لن يكون ضمن الاشتراك.',
  },
  {
    type: 'text',
    content: '<strong>3. الدفع</strong>',
  },
  {
    type: 'text',
    content:
      '<strong>3.1.</strong> يتعين عليك دفع ثمن الاشتراك وفقًا لشروط الدفع المذكورة في نموذج الطلب.',
  },
  {
    type: 'text',
    content:
      '<strong>3.2.</strong> سيبدأ الاشتراك الخاص بك الشهري عندما تؤكد تمارا سدادك وسيستمر لمدة ثلاثين (30) يومًا.',
  },
  {
    type: 'text',
    content:
      '<strong>3.3.</strong> عند شراء الاشتراك الشهري على تطبيق الجوال الخاص بتمارا، سيتم تطبيق خطة دفع مستمرة / متكررة تلقائيًا على حساب تمارا الخاص بك. في نهاية فترة الاشتراك الشهرية، سيتم تجديد اشتراكك تلقائيًا لمدة اشتراك إضافية مدتها ثلاثين (30) يومًا بالسعر الحالي في ذلك الوقت، ما لم يتم إلغاء الاشتراك الخاص بك من جهتك أو من جهتنا وفقًا للشروط والأحكام الخاصة بتمارا سمارت.',
  },
  {
    type: 'text',
    content: '<strong>4. إلغاء الاشتراك</strong>',
  },
  {
    type: 'text',
    content:
      '<strong>4.1.</strong> إذا كنت لا ترغب في تجديد اشتراكك تلقائيًا، فيمكنك إلغاؤه في أي وقت عن طريق تسجيل الدخول إلى حساب تمارا الخاص بك، واتباع التعليمات الموجودة على صفحة الحساب. ما لم تتم الإشارة إلى خلاف ذلك، سيصبح الإلغاء ساري المفعول اعتبارًا من نهاية فترة الفوترة التي قمت بالإلغاء خلالها.',
  },
  {
    type: 'text',
    content:
      '<strong>4.2.</strong> جميع الدفعات غير قابلة للاسترداد ولن يتم استردادها على أساس تناسبي لأي إلغاء يتم خلال مدة الاشتراك.',
  },
  {
    type: 'text',
    content:
      '<strong>4.3.</strong> إذا لم تسدد الدفعة المستحقة بموجب الاشتراك الخاص بك، فإن تمارا تحتفظ بالحق − دون أي مسؤولية تجاهك − في إنهاء ما تبقى من الاشتراك الخاص دون أي رسوم إضافية عليك.',
  },
  {
    type: 'text',
    content:
      '<strong>4.4.</strong> بالإضافة إلى أي حقوق أخرى قد تتمتع بها تمارا بموجب الشروط والأحكام الخاصة بتمارا سمارت، فإن تمارا تحتفظ تمارا − وفقًا لتقديرها الخاص − في تقييد حساب تمارا الخاص بك (بما في ذلك، على سبيل المثال لا الحصر إنهاء أي اشتراك نشط) أو اتخاذ أي إجراء آخر نعتبره مناسبًا لأي سوء استخدام للاشتراك الخاص بك أو أي عدم الامتثال لهذه الشروط والأحكام الخاصة بتمارا سمارت.',
  },
  {
    type: 'text',
    content:
      '<strong>4.5.</strong> إذا أُلغي الاشتراك الخاص بك أو أُنهي أو أصبح غير نشط لأي سبب من الأسباب، ستظل مسؤولاً عن دفع أي مبالغ مستحقة لتمارا، بما في ذلك المبالغ المتعلقة بتجربة كشف الحساب أو أي مبالغ أخرى بموجب الاشتراك الخاص بك.',
  },
  {
    type: 'subtitle',
    content: 'القسم الثالث',
  },
  {
    type: 'text',
    content: '<strong>التعريفات</strong>',
  },
  {
    type: 'text',
    content: 'تحمل الإشارات والكلمات والعبارات التالية المعاني التالية:',
  },
  {
    type: 'text',
    content:
      '<strong>الشروط والأحكام الخاصة بالعميل:</strong> تعني الشروط والأحكام الخاصة بالعميل المتاحة على الموقع الإلكتروني.',
  },
  {
    type: 'text',
    content:
      '<strong>المنازعة:</strong> يُقصد بها أي طلب رد أموال أو خصم أو تعويض أو مطالبة مضادة أو أي منازعة من أي نوع يقيمها العميل ضد التاجر فيما يتعلق بالسلع أو الخدمات التي نتجت عنها معاملة معتمدة.',
  },
  {
    type: 'text',
    content:
      '<strong>معلومات التعريف:</strong> يُقصد بها المعلومات المطلوبة التي يجب أن يقدمها العميل إلى تمارا لإنشاء حساب له مع تمارا، والتي تجمعها تمارا أو التاجر أو منصة التاجر لأغراض تقديم خدمات تمارا للعملاء.',
  },
  {
    type: 'text',
    content:
      '<strong>منصة التاجر:</strong> يُقصد بها وسائل تتيح لعدة تجار تقديم السلع والخدمات للعملاء من خلال منصة واحدة، ومن ضمنها مثلاً المواقع الإلكترونية والتطبيقات',
  },
  {
    type: 'text',
    content:
      '<strong>التاجر:</strong> يعني أي كيان تجاري يسمح لعملائه بالاستفادة من خدمات تمارا بموجب اتفاقية مستقلة؛ وَفق ما يُستَجَدّ من وقت لآخر.',
  },
  {
    type: 'text',
    content:
      '<strong>تطبيق الجوال:</strong> يعني تطبيق الجوال الخاص بتمارا المتاح للتنزيل من المتاجر الرقمية ذات الصلة.',
  },
  {
    type: 'text',
    content:
      '<strong>نموذج الطلب:</strong> يعني صفحة طلب الاشتراك عبر الإنترنت التي تحدد رسوم الدفع ومدة المدة التي تنطبق على حزمة الاشتراك.',
  },
  {
    type: 'text',
    content:
      '<strong>طلب الشراء:</strong> يعني الطلب المقدم من العميل من خلال منصة التاجر أو الموقع الإلكتروني أو تطبيق الجوال أو الموقع الإلكتروني الخاص بالتاجر أو أي تطبيقات أو نقاط بيع أخرى لاستخدام خدمات تمارا لشراء السلع أو الخدمات من التاجر أو منصة التاجر ذات الصلة.',
  },
  {
    type: 'text',
    content:
      '<strong>استرداد الأموال</strong> يُقصد بها المبلغ (الذي ربما يكون متنازعًا عليه) والذي يكون العميل قد دفعه إلى تاجر باستخدام خدمات تمارا فيما يتعلق بمعاملة معتمدة، ثم يُرد لاحقًا إلى العميل بعد تسوية هذه المنازعة.',
  },
  {
    type: 'text',
    content:
      '<strong>الاشتراك:</strong> يعني الاشتراك الذي تشتريه وفقًا لنموذج الطلب حتى تتمكن من الوصول إلى تمارا سمارت.',
  },
  {
    type: 'text',
    content:
      '<strong>تمارا:</strong> تعني شركة تمارا (م.م.ح)، مؤسسة ومسجلة في دولة الإمارات العربية المتحدة برقم L-602، إلى جانب جميع شركات المجموعة والشركات التابعة لها.',
  },
  {
    type: 'text',
    content:
      '<strong>حساب تمارا:</strong> يعني الحساب الذي قمت بإنشائه (كعميل) لاستخدام خدمات تمارا، والذي سيخضع استخدامه وتشغيله للشروط والأحكام الخاصة بالعميل.',
  },
  {
    type: 'text',
    content:
      '<strong>برنامج تمارا لحماية المشتري:</strong> كما هو موضح في الشروط والأحكام الخاصة بالعميل.',
  },
  {
    type: 'text',
    content:
      '<strong>خدمات تمارا:</strong> تعني خدمات الدفع والتمويل التي تقدمها تمارا وَفق ما يُستَجَدّ من وقت لآخر، والتي تحددها أنت كعميل على الموقع الإلكتروني الخاص بالتاجر أو منصة التاجر أو في أي نقطة بيع أخرى مع التاجر والتي بموجبها تختار أنت كعميل شراء السلع أو الخدمات من التاجر أو منصة التاجر باستخدام خدمات تمارا الخاضعة للشروط والأحكام الخاصة بالعميل.',
  },
  {
    type: 'text',
    content:
      '<strong>تمارا سمارت:</strong> تعني خدمة تمارا القائمة على الاشتراك والتي تتيح لك الحصول على المزايا الموضحة في البند (2.1) أعلاه، وفقًا للشروط والأحكام الخاصة بتمارا سمارت.',
  },
  {
    type: 'text',
    content:
      '<strong>المعاملة:</strong> تعني الطلب المقدم عبر حساب تمارا الخاص بك وفقًا لطلب الشراء؛ للاستفادة من خدمات تمارا من أجل إكمال وتسوية هذا الأمر مع التاجر أو منصة التاجر ذات الصلة.',
  },
  {
    type: 'text',
    content:
      '<strong>الشروط والأحكام الخاصة بتمارا سمارت</strong> تعني هذه الشروط والأحكام بصيغتها المعدلة من وقت لآخر.',
  },
  {
    type: 'text',
    content:
      '<strong>نحن:</strong> الإشارات إلى ضمير المتكلم المنفصل "نحن" أو ضمير المتكلم المتصل "نا" أو أية ضمائر أخرى مماثلة في هذه الشروط والأحكام هي إشارات إلى تمارا والكيانات والأشخاص التابعين لها.',
  },
  {
    type: 'text',
    content:
      '<strong>الموقع الإلكتروني:</strong>يعني موقع تمارا على العنوان التالي <a href="https://tamara.co">https://tamara.co.</a>',
  },
  {
    type: 'text',
    content:
      '<strong>أنت:</strong> الإشارات إلى ضمير المُخاطَب المنفصل "أنت" أو المُخاطَب المتصل "ك" أو أية ضمائر أخرى مماثلة في هذه الشروط والأحكام هي إشارات إلى العميل ذي الصلة المشار إليه في معلومات التعريف التي يجب تقديمها قبل استخدام خدمات تمارا.',
  },
]
